import React from 'react';
import { Box, Badge } from '@drone-js/core';
import { useSelector } from 'react-redux';
import { selectConfigFromBootstrap } from 'store/slice/bootstrap';
import { RankScore } from 'gql/autogen/RankScore';

export interface Props {
    supplierId?: number;
    activityId?: number;
    masterActivityId?: number;
    supplierActivityCode?: string;
    offerId?: number;
    supplierOfferCode?: string;
    categories?: string[];
    rankScore?: RankScore;
}

const DebugItem: React.FC<{ data?: string | number; label?: string }> = (props) => {
    return <Badge variant="secondary.neutral-2" mb="4" me="4" label={props.label ? `${props.label}: ${props.data}` : String(props.data)} />;
};
DebugItem.displayName = 'DebugItem';

const DebugInformation: React.FC<Props> = (props) => {
    const config = useSelector(selectConfigFromBootstrap);
    if (!config.isDebug) {
        return null;
    }

    const categories = props.categories?.join(', ');
    const supplierId = props.supplierId;
    const rankScore = props.rankScore ? props.rankScore.value : '-';
    const supplierActivityCode = props.supplierActivityCode || '-';
    const supplierOfferCode = props.supplierOfferCode || '-';
    return (
        <Box display="flex" flexWrap="wrap">
            {/* eslint-disable-next-line @agoda/agoda-a11y/no-hardcoded-content -- @agoda/agoda-a11y/no-hardcoded-content[6dd85ab0-5ea9-470d-a49c-adea3524dedd] */}
            <DebugItem key="supplierId" data={supplierId} label="supplierId" />
            {/* eslint-disable-next-line @agoda/agoda-a11y/no-hardcoded-content -- @agoda/agoda-a11y/no-hardcoded-content[ffdfe2a8-5b27-4f14-bec6-63401695cdbc] */}
            <DebugItem key="masterActivityId" data={props.masterActivityId} label="masterActivityId" />
            {/* eslint-disable-next-line @agoda/agoda-a11y/no-hardcoded-content -- @agoda/agoda-a11y/no-hardcoded-content[81b1f4fa-6a2c-4382-9fc2-051a9578dcf8] */}
            <DebugItem key="activityId" data={props.activityId} label="activityId" />
            {/* eslint-disable-next-line @agoda/agoda-a11y/no-hardcoded-content -- @agoda/agoda-a11y/no-hardcoded-content[8ccc3de0-742d-4d9e-882f-731d6be3ff0b] */}
            <DebugItem key="supplierActivityCode" data={supplierActivityCode} label="supplierActivityCode" />
            {/* eslint-disable-next-line @agoda/agoda-a11y/no-hardcoded-content -- @agoda/agoda-a11y/no-hardcoded-content[7646301c-3c77-4fe8-b048-92c7579ef8ef] */}
            <DebugItem key="offerId" data={props.offerId} label="offerId" />
            {/* eslint-disable-next-line @agoda/agoda-a11y/no-hardcoded-content -- @agoda/agoda-a11y/no-hardcoded-content[d1205fef-891b-4754-bc6a-908d90d40e58] */}
            <DebugItem key="supplierOfferCode" data={supplierOfferCode} label="supplierOfferCode" />
            {/* eslint-disable-next-line @agoda/agoda-a11y/no-hardcoded-content -- @agoda/agoda-a11y/no-hardcoded-content[72e2fd8d-6d54-4e47-a860-bdaca36409b0] */}
            <DebugItem key="categories" data={categories} label="categories" />
            {/* eslint-disable-next-line @agoda/agoda-a11y/no-hardcoded-content -- @agoda/agoda-a11y/no-hardcoded-content[8c3e60c7-d31a-4653-bc1a-1472248a5ddb] */}
            <DebugItem key="rankScore" data={rankScore} label="rankScore" />
        </Box>
    );
};
DebugInformation.displayName = 'DebugInformation';

export default DebugInformation;
